import { useState } from 'react'
import { isFulfilled } from '@reduxjs/toolkit'

import { useAppDispatch } from 'reduxTyped'
import { retryPayment } from 'common/billing/actions/billingActions'
import { analyticsService } from 'utils/services/analytics'

interface UseRetryPayment {
  isLoading: boolean
  handleRetryPayment: () => void
  isPaymentSuccessful: null | boolean
}

export const useRetryPayment = (source?: string): UseRetryPayment => {
  const [isLoading, setIsLoading] = useState(false)
  const [isPaymentSuccessful, setIsPaymentSuccessful] = useState<null | boolean>(null)

  const dispatch = useAppDispatch()
  const handleRetryPayment = async () => {
    if (isLoading) {
      return
    }
    setIsLoading(true)
    analyticsService.sendEvent(`${source}.RETRY_PAYMENT.BUTTON.CLICK`, { source })
    const result = await dispatch(retryPayment())
    if (isFulfilled(result)) {
      setIsPaymentSuccessful(true)
    }
    setIsLoading(false)
  }

  return { isLoading, handleRetryPayment, isPaymentSuccessful }
}
